module.exports = __webpack_public_path__ + "static/bank-2a7e8e16b0812f9452d52f2edd012d22.jpg";